import React from "react";
import List from "devextreme-react/list";
import FileData3D from "@/pages/takeoff/context/project-organisation/models/file-data-3d";


export interface File3DListProps {
    itemsSource: FileData3D[];
}

const File3DList: React.FC<File3DListProps> = ({itemsSource}) => {
    
    const ItemTemplate= function(item: FileData3D) {
        return (
            <div className='flex flex-row w-full items-center'>
                <div className='flex-1' title={`${item.name}`}>{item.name}</div>
            </div>
        )
    }

    return (
        <div className='border border-gray-200 rounded-lg'>
            <List dataSource={itemsSource} keyExpr={'id'} displayExpr={'name'}
                  itemRender={ItemTemplate}
                  repaintChangesOnly={true} noDataText='Aucun fichier'
                  hoverStateEnabled={false} selectByClick={false} focusStateEnabled={false} activeStateEnabled={false}>
            </List>
        </div>
    )
}

export default File3DList;